import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');
const moment = require('moment');

export function getNotes(env, projectdId, issueId) {
    return () => {
        return apiCaller
            .call(api.getNotes(env, projectdId, issueId))
            .then(({ data }) => {
                let notes = [];
                data.forEach(({ id, body, author, created_at }) => {
                    author = author.name;
                    created_at = moment(created_at).format('DD/MM/YYYY HH:mm:ss');
                    const note = { id, body, author, created_at };
                    notes.push(note);
                });
                return notes;
            })
            .catch(error => {
                Logger.error('dataActions: getNotes - ', error);
                throw error;
            });
    };
}
export function createNote(env, projectId, issueId, body) {
    return () => {
        return apiCaller
            .call(api.createNote(env, projectId, issueId, body))
            .then(({ data }) => {
                if (data) {
                    const { id, body, author, created_at } = data;
                    return { id, body, author: author.name, created_at: moment(created_at).format('DD/MM/YYYY HH:mm:ss') };
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: createIssue - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Notes/actions.js